import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from "./OrganizationAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";

export const ACTIVITY_TYPES = {
    PROJECT_INVITES: 'project-invites',
    JOINED_PROJECT: 'joined-project',
    PROPERTY_FAVORITED: 'property-favorited',
    TASK_ASSIGNED: 'task-assigned-to-you',
    EVENT_INVITES: 'event-invites',
    PROJECT_BILLBOARD_COMPLETED: 'project-billboard-completed',
    UNDER_CONTRACT: 'under-contract-process-created',
    TASK_COMPLETED: 'task-completed',
    TASK_MARKED_INCOMPLETE: 'task-marked-in-complete',
    TASK_CREATED: 'task-created',
    TASK_DELETED: 'task-deleted',
    EVENT_CREATED: 'event-created',
    EVENT_DELETED: 'event-deleted',
    FILE_UPLOADED: 'file-uploaded',
    FILE_DELETED: 'file-deleted',
    REMOVED_FROM_PROJECT: 'removed-from-project',
    PROJECT_MEMBER_REMOVED: 'project-member-removed',
    PROJECT_MEMBER_LEFT: 'project-member-left',
    LATEST_CHAT_MESSAGE: 'chat-message-created',
    FORM_SIGNED: 'form-signed',
    NEW_PROJECT_CREATED: 'new-project-created',
    ONBOARDING_COMPLETED: 'onboarding-completed',
    UPDATED_MORTGAGE_DETAILS: 'updated-mortgage-details',
    ARTICLE_VIEWED: 'article-viewed',
    VIDEO_VIEWED: 'video-viewed',
    HOMEOWNERS_INSURANCE_UPDATED: 'homeowners-insurance-updated',
    HOME_WARRANTY_UPDATED: 'homeowners-warranty-updated',
    HOME_VALUATION_UPDATED: 'home-validation-updated',
    SERVICE_PROVIDER_SEARCHED: 'service-provider-search',
    SERVICE_PROVIDER_REQUESTED: 'service-provider-requested',
    SERVICE_PROVIDER_VIEWED: 'service-provider-viewed',
    SERVICE_PROVIDER_SENT_MESSAGE: 'service-provider-sent-message',
    PROPERTY_SEARCHED: 'property-searched',
    PROPERTY_SEARCH_SAVED: 'property-search-saved',
    HOME_BUDGET_UPDATED: 'home-budget-updated',
    LISTING_PURCHASE_ASSUMPTIONS: 'listing-purchase-assumptions',
    TRADE_IN_PROCESS_STARTED: 'trade-in-process-started',
    OFFER_STARTED: 'offer-started',
    MORTGAGE_APPLICATION_STARTED: 'mortgage-application-started',
    ENTERED_HOME_DETAILS: 'entered-home-details',
    TURNED_ON_BROWSER_NOTIFICATIONS: 'turned-on-browser-notifications',
    CONNECTED_CALENDAR: 'connected-calendar',
    UNSUBSCRIBED_FROM_CAMPAIGN: 'unsubscribed-from-campaign',
    VISITED_A_HUB: 'visited-a-hub',
    VISITED_SERVICE_PROVIDER_WEBSITE: 'visited-service-provider-website',
    CONTACTED_RE_AGENT: 'contacted_real_estate_agent',
    CONTACTED_LOAN_OFFICER: 'contacted_loan_officer',
    PROPERTY_REMODEL_FAVORITED: 'property-remodel-favorited',
    VISITED_LISTING_WEBSITE: 'visited-listing-website',
    SUBMITTED_LISTING_INQUIRY: 'submitted-listing-inquiry',
    VIEWED_HOME_VALUE: 'viewed-home-value',
};

class ActivityAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Activity';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'activities';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'count',
            'datetime',
            'description',
            'members',
            "users",
            'meta',
            'name',
            'organizationMemberUuid',
            'organizationUuid',
            'project',
            'projectMemberName',
            'projectMemberEmail',
            'projectMemberType',
            'projectMemberTypeUuid',
            'projectMemberUuid',
            'projectMemberWithTrashed',
            'projectName',
            'projectType',
            'projectTypeUuid',
            'projectUuid',
            'redirectUrl',
            'type',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            project: WorkspaceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            project: 'project_uuid',
            projectType: 'project_type_uuid',
            projectMember: 'project_member_uuid',
            projectMemberWithTrashed: 'project_member_uuid',
            projectMemberRole: 'project_member_role',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return [];
    }

}

export default ActivityAppResource;
